@if (calendar$ | async; as calendar) {
<div class="meeting-info">
  <div class="profile-width">
    <span
      class="avatar"
      [ngStyle]="{
        'background-image':
          'url(' +
          (calendar.displayProfileUrl || './assets/images/profile.svg') +
          ')'
      }"
    >
    </span>
    <span data-testid="host-display-name" [appTooltip]="displayNameTooltip">
      {{ displayName$ | async }}</span
    >
  </div>
  <ng-content select="[banner-header-content]"></ng-content>
</div>
<div class="meeting-info">
  <ng-content select="[banner-location-information]"></ng-content>
</div>
<div class="meeting-description">
  <ng-content select="[banner-header-description]"></ng-content>
</div>
}
